module.exports = __webpack_public_path__ + "static/media/icon-dashboard.c0c8a6a3.svg";